export const en = {
  header: {
    brandSubtitle: "Careers Portal",
    openings: "Openings",
    howToApply: "How to apply",
    lifeAtMMMOCL: "Life at MMMOCL",
    notices: "Notices",
    help: "Help",
    signIn: "Sign in",
    register: "Register",
    signedInAs: "Signed in as",
    myProfile: "My Profile",
    logout: "Logout",
  },
  footer: {
    title: "Maha Mumbai Metro Operation Corporation Ltd.",
    copyright: "MMMOCL. A Government of Maharashtra Undertaking.",
    privacy: "Privacy",
    terms: "Terms",
    accessibility: "Accessibility",
    rti: "RTI",
    contact: "Contact",
  },
  home: {
    heroBadge: "Maha Mumbai Metro Careers",
    heroTitle: "Build Mumbai's Lifeline",
    heroSubtitle:
      "Join the dedicated team powering modern, reliable, and sustainable transit for millions across the Mumbai Metropolitan Region.",
    exploreOpenings: "Browse Openings",
    howItWorks: "How to Apply",
    activeHiringBadge: "Actively hiring across operations, engineering & corporate",

    searchPlaceholder: "Search by job title, role, or keywords...",
    allDepartments: "All Departments",
    anyType: "Any type",
    allLocations: "All Locations",
    searchBtn: "Search",
    resetFilters: "Reset Filters",
    showingResults: "Showing {count} openings",

    statOpenings: "Current Openings",
    statLines: "Metro Lines",
    statApplicants: "Registered Candidates",
    statGrowth: "Corridor Expansion",

    whyJoinTitle: "Why Build Your Career at MMMOCL?",
    whyJoinSubtitle:
      "Be part of Maharashtra's premier mass rapid transit organization and shape public mobility.",
    benefit1Title: "Structured Compensation",
    benefit1Desc:
      "Competitive government pay scales, health coverage, pension benefits, and metro travel allowances.",
    benefit2Title: "Job Security & Welfare",
    benefit2Desc:
      "Long-term public sector stability with comprehensive family medical benefits and employee care programs.",
    benefit3Title: "Skill Development",
    benefit3Desc:
      "Specialized training at the world-class MMMOCL Metro Training Academy and clear career advancement pathways.",
    benefit4Title: "Public Impact",
    benefit4Desc:
      "Directly contribute to reducing urban road congestion, cutting carbon emissions, and connecting millions daily.",

    howToTitle: "Application Process",
    howToSubtitle: "Three simple steps to start your metro career journey.",
    step1Title: "1. Create Profile",
    step1Desc: "Register your candidate account with your educational details and identity documents.",
    step2Title: "2. Explore & Apply",
    step2Desc: "Filter vacancies by department, check your age eligibility, and submit your application.",
    step3Title: "3. Track Status",
    step3Desc: "Receive instant updates on shortlisting, written exams, and interview schedules.",

    noJobsTitle: "No openings match your search",
    noJobsDesc: "Try adjusting your search criteria or resetting filters to see all available openings.",
    applyBy: "Apply by",
    postedOn: "Posted on",
    viewDetails: "View Details",
    applyNow: "Apply Now",
    alreadyApplied: "Already Applied",
    closingSoonTag: "Closing soon",
    newTag: "New",
    activelyHiring: "Actively hiring",

    paginationPrevious: "Previous",
    paginationNext: "Next",
    paginationPageOf: "Page {current} of {total}",
    itemsPerPage: "Items per page",

    alertsTitle: "Stay Informed on New Openings",
    alertsDesc: "Subscribe to official MMMOCL notifications when fresh recruitment notices are published.",
    alertsPlaceholder: "Enter your email address",
    alertsSubscribeBtn: "Subscribe",
    alertsSuccess: "You're subscribed to MMMOCL job alerts!",
  },
  jobDetails: {
    backToOpenings: "Back to openings",
    breadcrumbHome: "Home",
    breadcrumbOpenings: "Openings",
    deptLabel: "Department",
    typeLabel: "Employment Type",
    locationLabel: "Location",
    salaryLabel: "Salary Range",
    deadlineLabel: "Application Deadline",
    ageLabel: "Age Eligibility",
    notSpecified: "Not specified",
    asPerNorms: "As per government norms",

    overviewHeading: "Job Overview",
    responsibilitiesHeading: "Key Responsibilities",
    qualificationsHeading: "Eligibility & Educational Qualifications",
    skillsHeading: "Preferred Competencies & Skills",
    selectionHeading: "Selection Process",
    benefitsHeading: "Employee Benefits & Allowances",

    defaultBenefits: [
      "Structured government pay scale with applicable DA & HRA",
      "Comprehensive medical and health insurance coverage",
      "Provident Fund, gratuity, and retirement benefits",
      "Metro transit pass and shift operational allowances",
      "Specialized training at MMMOCL Training Academy",
      "Merit-based promotion and career progression opportunities",
    ],
    defaultStages: [
      "Online application screening",
      "Written test / Technical assessment",
      "Document verification & medical examination",
      "Personal interview & final selection",
    ],

    stickyTitle: "Interested in this position?",
    applyForJob: "Apply for this opening",
    alreadyAppliedBtn: "Already Applied",
    loginToApply: "Sign in to Apply",
    deadlinePassed: "Applications Closed",
    shareTitle: "Share Opening",
    shareCopied: "Link copied to clipboard!",
  },
  apply: {
    pageTitle: "Job Application",
    pageSubtitle: "Submit your candidature for {title}",
    backToJob: "Back to Job Posting",
    applicantSnapshot: "Applicant Details (from your profile)",
    fullName: "Full Name",
    email: "Email Address",
    mobile: "Mobile Number",
    experience: "Total Experience",
    currentCtc: "Current CTC",
    expectedCtc: "Expected CTC",
    editProfileHint: "To update your contact or educational details, edit your Profile.",

    resumeHeading: "Resume / Curriculum Vitae",
    resumeOnFile: "Resume on File",
    replaceResume: "Replace with another file",
    keepExisting: "Keep profile resume",
    uploadResume: "Upload Resume (PDF, DOCX up to 5MB)",

    coverLetterHeading: "Cover Letter / Statement of Purpose (Optional)",
    coverLetterPlaceholder:
      "Explain why you are an ideal fit for this role, your relevant metro/rail transit experience, and key accomplishments...",

    additionalHeading: "Additional Professional Links",
    portfolioUrl: "Portfolio / Work Samples URL",
    linkedinUrl: "LinkedIn Profile URL",
    noticePeriod: "Notice Period",
    noticePeriodSelect: "Select notice period",
    noticeImmediate: "Immediate joiner",
    notice15Days: "15 days or less",
    notice30Days: "1 month (30 days)",
    notice60Days: "2 months (60 days)",
    notice90Days: "3 months (90 days)",

    declarationHeading: "Declaration & Consent",
    declarationText:
      "I hereby declare that all particulars furnished by me in this application are true, complete, and correct to the best of my knowledge and belief. I understand that any false information will disqualify me from the recruitment process.",

    submitApplication: "Submit Application",
    submitting: "Submitting...",
    cancel: "Cancel",

    successTitle: "Application Submitted Successfully",
    alreadyAppliedTitle: "Application Already Submitted",
    successMsg:
      "Thank you for applying to {title}. Your application reference number is {ref}. Our recruitment team will review your credentials against the eligibility criteria.",
    alreadyAppliedMsg:
      "You have already applied for this opening. You can monitor your application status, interview schedules, and updates on your profile page.",
    viewProfileBtn: "View My Applications",
    backHomeBtn: "Browse More Openings",
  },
  auth: {
    loginTitle: "Sign in to Candidate Portal",
    loginSubtitle: "Track applications, view interview schedules, and manage your profile.",
    emailOrMobile: "Email or Mobile Number",
    password: "Password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    signInBtn: "Sign In",
    noAccount: "Don't have an account?",
    registerHere: "Register now",

    registerTitle: "Candidate Registration",
    registerSubtitle: "Create your profile to apply for MMMOCL metro recruitment openings.",
    hasAccount: "Already registered?",
    signInLink: "Sign in here",

    stepAccount: "Account",
    stepContact: "Contact",
    stepEducation: "Education",
    stepExperience: "Experience",
    stepDocuments: "Documents",

    step1Title: "Account Credentials",
    fullNameLabel: "Full Legal Name (as per Aadhaar)",
    mobileLabel: "10-digit Mobile Number",
    emailLabel: "Email Address",
    dobLabel: "Date of Birth",
    passwordLabel: "Create Password",
    confirmPasswordLabel: "Confirm Password",
    passwordHint: "Must be at least 8 characters long.",

    step2Title: "Residential Contact Details",
    addressLabel: "Full Residential Address",
    cityLabel: "City / District",
    stateLabel: "State",
    pinLabel: "PIN Code (6 digits)",

    step3Title: "Educational Background",
    qualificationLabel: "Highest Qualification",
    selectQualification: "Select qualification",
    universityLabel: "University / Board / Institution",
    passingYearLabel: "Passing Year (YYYY)",
    percentageLabel: "Percentage / CGPA",

    step4Title: "Employment Experience",
    candidateTypeLabel: "Candidate Type",
    typeFresher: "Fresher",
    typeExperienced: "Experienced Professional",
    employerLabel: "Current / Most Recent Employer",
    totalExpLabel: "Total Experience (Years/Months)",
    relevantExpLabel: "Relevant Metro/Transit Experience",
    currentCtcLabel: "Current CTC (₹)",
    expectedCtcLabel: "Expected CTC (₹)",

    step5Title: "Document Verification Uploads",
    uploadResumeLabel: "Resume / CV (PDF, max 5MB)",
    uploadPhotoLabel: "Recent Passport Photo (JPG/PNG, max 2MB)",
    uploadAadhaarLabel: "Aadhaar Card Copy (PDF/JPG, max 5MB)",
    uploadPanLabel: "PAN Card Copy (Optional, PDF/JPG)",
    uploadCertificatesLabel: "Educational Certificates (PDF, max 10MB)",
    termsAgreement:
      "I agree to the Terms of Recruitment and declare that all submitted information is authentic and verifiable.",

    nextBtn: "Continue",
    prevBtn: "Previous",
    finishRegistration: "Complete Registration",
    registering: "Creating Account...",

    registrationCompleteTitle: "Profile Created Successfully!",
    registrationCompleteMsg:
      "Your candidate profile has been registered. You can now explore vacancies and submit applications directly.",
    proceedToLogin: "Proceed to Login",

    forgotTitle: "Reset Your Password",
    forgotSubtitle: "Enter your registered email address to receive password reset instructions.",
    sendResetLink: "Send Reset Link",
    backToLogin: "Back to Sign In",
  },
  profile: {
    pageTitle: "Candidate Profile & Applications",
    pageSubtitle: "Manage your credentials and track recruitment status.",
    tabApplications: "My Applications",
    tabProfile: "Candidate Details",

    noApplicationsTitle: "No Applications Yet",
    noApplicationsDesc: "You haven't submitted any job applications yet. Browse our live openings and apply.",
    browseJobsBtn: "Browse Live Openings",

    appRef: "Reference",
    appRole: "Position",
    appDept: "Department",
    appDate: "Applied Date",
    appStatus: "Status",
    appActions: "Details",

    interviewScheduledAlert: "Interview Scheduled!",
    interviewDate: "Date & Time",
    interviewType: "Mode",
    interviewVenue: "Location / Link",
    interviewNotes: "Hiring Team Notes",
    virtualMode: "Online / Virtual",
    onsiteMode: "In-Person / Onsite",
  },
  common: {
    loading: "Loading...",
    error: "An error occurred. Please try again.",
    tryAgain: "Try Again",
    permanent: "Permanent",
    contract: "Contract",
    temporary: "Temporary",
    perYear: "year",
    perMonth: "month",
    perDay: "day",
    perHour: "hour",
    years: "years",
    upTo: "Up to",
    yearsOld: "years",
    statusApplied: "Applied",
    statusUnderReview: "Under Review",
    statusShortlisted: "Shortlisted",
    statusInterviewScheduled: "Interview Scheduled",
    statusInterviewed: "Interviewed",
    statusRejected: "Not Selected",
    statusHired: "Selected",
    statusSelected: "Selected",
  },
};
